const STORAGE_KEY = 'gcodr:open-tabs'

interface PersistedTabs {
  activeJobId: string | null
  openJobIds: string[]
}

const DEFAULT: PersistedTabs = { activeJobId: null, openJobIds: [] }

export function loadPersistedTabs(): PersistedTabs {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return DEFAULT
    const parsed = JSON.parse(raw)
    if (Array.isArray(parsed.openJobIds)) return parsed as PersistedTabs
    return DEFAULT
  } catch {
    return DEFAULT
  }
}

export function savePersistedTabs(tabs: PersistedTabs): void {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(tabs))
}

export function addOpenTab(id: string): void {
  const tabs = loadPersistedTabs()
  if (!tabs.openJobIds.includes(id)) {
    tabs.openJobIds.push(id)
  }
  savePersistedTabs(tabs)
}

export function removeOpenTab(id: string): void {
  const tabs = loadPersistedTabs()
  tabs.openJobIds = tabs.openJobIds.filter(x => x !== id)
  if (tabs.activeJobId === id) {
    tabs.activeJobId = tabs.openJobIds[tabs.openJobIds.length - 1] ?? null
  }
  savePersistedTabs(tabs)
}
